import PageComponent from '../base/PageComponent';

export default class PropertyTileModule extends PageComponent {
    init() {
        this.blogCarousel();
        this.mobileBlogCarousel();
        this.twitterCarousel();
        this.mobileTwitterCarousel();
        this.propertyCarousel();
    }

    loadMasonry() {
        this.masonry = new MasonryComponent(this.childElements('.listing__item-container').get(0));
        this.masonry.init();
        //this.masonry.setLoadUrl(this.element.data('load-url'));
    }

    blogCarousel(){
        this.childElements('.hidden-sm .Blog__carousel').slick({
            slide: '.hidden-sm .Blog__carousel > li',
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 1000,
            adaptiveHeight: false,
            dots: true,
            appendDots: $('.hidden-sm .listing__item--Blog'),
            dotsClass: 'slick-dots slick-dots--light',
            customPaging: function () {
                return '<span></span>';
            },
            slidesToShow: 1,
            infinite: false,
            arrows: false
        });
    }

    mobileBlogCarousel(){
        this.childElements('.mobile-only .Blog__carousel').slick({
            slide: '.mobile-only .Blog__carousel > li',
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 1000,
            adaptiveHeight: false,
            dots: true,
            appendDots: $('.mobile-only .listing__item--Blog'),
            dotsClass: 'slick-dots slick-dots--light',
            customPaging: function () {
                return '<span></span>';
            },
            slidesToShow: 1,
            infinite: false,
            arrows: false
        });
    }

    twitterCarousel(){
        this.childElements('.hidden-sm .Tweets').slick({
            slide: '.hidden-sm .Tweets .Tweet',
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 1000,
            adaptiveHeight: false,
            dots: true,
            appendDots: $('.hidden-sm .listing__item--Twitter'),
            dotsClass: 'slick-dots slick-dots--light',
            customPaging: function () {
                return '<span></span>';
            },
            slidesToShow: 1,
            infinite: false,
            arrows: false
        });
    }

    mobileTwitterCarousel(){
        this.childElements('.mobile-only .Tweets').slick({
            slide: '.mobile-only .Tweets .Tweet',
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 1000,
            adaptiveHeight: false,
            dots: true,
            appendDots: $('.mobile-only .listing__item--Twitter'),
            dotsClass: 'slick-dots slick-dots--light',
            customPaging: function () {
                return '<span></span>';
            },
            slidesToShow: 1,
            infinite: false,
            arrows: false
        });
    }

    propertyCarousel() {
        this.childElements('.property-tile__carousel').slick({
            slide: 'li',
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 1000,
            adaptiveHeight: false,
            dots: true,
            appendDots: $('.property-tile__carousel'),
            dotsClass: 'slick-dots slick-dots--light',
            customPaging: function () {
                return '<span></span>';
            },
            slidesToShow: 1,
            infinite: false,
            arrows: false
        });
    }
}


// WEBPACK FOOTER //
// ./javascript/modules/PropertyTileModule.js